import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import './AccountPage.css';

function AccountPage() {
  const { user } = useContext(AuthContext); // Use AuthContext for proper role/status access
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('User logged out');
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error.message);
    }
  };

  const getRoleDisplayName = (role) => {
    switch (role) {
      case 'admin': return 'Administrator';
      case 'supplier': return 'Supplier';
      case 'user': return 'User';
      default: return 'Unknown';
    }
  };

  const getStatusDisplayName = (status) => {
    switch (status) {
      case 'active': return 'Active';
      case 'pending': return 'Pending Approval';
      case 'suspended': return 'Suspended';
      case 'rejected': return 'Rejected';
      default: return 'Unknown';
    }
  };

    return (
    <div className="account-page">
      <h1>Account Details</h1>

      <div className="account-card">
        <div className="account-card__section">
          <h3>Profile Information</h3>
          <div className="account-kv">
            <div><strong>Role:</strong> {getRoleDisplayName(user?.role)}</div>
            <div><strong>Email:</strong> {user?.email || 'N/A'}</div>
            <div><strong>Status:</strong> {getStatusDisplayName(user?.status)}</div>

            {user?.role === 'supplier' && user?.companyProfile && (
              <>
                <div><strong>Company:</strong> {user.companyProfile.companyName || 'Not provided'}</div>
                <div><strong>Contact Person:</strong> {user.companyProfile.primaryContact || 'Not provided'}</div>
                <div><strong>Phone:</strong> {user.companyProfile.phoneNumber || 'Not provided'}</div>
                <div><strong>Website:</strong> {user.companyProfile.website || 'Not provided'}</div>
              </>
            )}

            <div><strong>Account Created:</strong> {user?.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'N/A'}</div>
            <div><strong>Last Login:</strong> {user?.lastLogin ? new Date(user.lastLogin).toLocaleDateString() : 'N/A'}</div>
          </div>
        </div>

        <div className="account-card__section">
          <h3>Quick Actions</h3>
          <div className="account-actions-grid">
            {user?.role === 'user' && (
              <button className="btn btn--primary" onClick={() => navigate('/user/dashboard')}>
                Open My Dashboard
              </button>
            )}

            {user?.role === 'supplier' && (
              <button className="btn btn--primary" onClick={() => navigate('/supplier/dashboard')}>
                Open Supplier Dashboard
              </button>
            )}

            {user?.role === 'admin' && (
              <>
                <button className="btn btn--primary" onClick={() => navigate('/dashboard')}>
                  Open Admin Dashboard
                </button>
                <button className="btn btn--secondary" onClick={() => navigate('/admin/user-management')}>
                  Manage Users
                </button>
                <button className="btn btn--secondary" onClick={() => navigate('/logs')}>
                  View Logs
                </button>
              </>
            )}

            <button className="btn btn--secondary" onClick={handleLogout}>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountPage;
